export const homeFaqItems = [
  {
    question: "What is Anubandh.org Vadhu Var Search?",
    answer:
      "Anubandh.org Arya Vaishya Komti Samaj Vadhu Var search is an online brand of 'Marathi Vadhu Var Suchak', which showcase well educated Arya Vaishya Komti Samaj Vadhu Var list on single click. This service is simply a free online classified of 'Marathi Vadhu Var Suchak'.",
  },
  {
    question: "What are the benefits of Anubandh.org Vadhu Var Search?",
    answer:
      "Well educated Arya Vaishya Komti Samaj Vadhu Var can search and view verified profiles on just a one click with a short information with photo.",
  },
  {
    question: "How could I add my profile on Anubandh.org Vadhu Var list?",
    answer:
      "Very easy! Just register free through the 'MarathiVadhuVarSuchak.com' app. And your profile will be displayed on Anubandh.org list too.",
  },
  {
    question:
      "How could I see the full profile, viewed on Anubandh.org search?",
    answer:
      "First you have to register free on 'MarathiVadhuVarSuchak.com' and where you can see the full profile, which was viewed on Anubandh.org Vadhu Var search result.",
  },
  {
    question: "Can I use Anubandh.org Vadhu Var search for free?",
    answer:
      "Yes! Anubandh.org Arya Vaishya Komti Samaj Vadhu Var search is free. The parent site 'MarathiVadhuVarSuchak.com' also allowed a free online registration.",
  },
] as const;
